// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__RNgMe","content":"LoadingAlert_content__1N6H4"};